import BoardLayout from 'components/layouts/Board/BoardLayout';
import {Loader} from 'components/Theme';
import {Suspense} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {AppRoute} from './AppRoute';
import {authRoutes, protectedRoutes, publicRoutes} from './config';
import {AuthenticationGuard} from '../guards/AuthenticationGuard';
import {AuthorityGuard} from '../guards/AuthorityGuard';
import AuthRouteRenderer from '../guards/AuthRouteRenderer';
import PublicRouteRenderer from './PublicRouteRenderer';
import TenantGurd from 'guards/TenantGurd';

const AllRoutes = () => {
    return (
        <Routes>
            <Route
                key={'ProtectedRoutes'}
                path="/"
                element={
                    <AuthenticationGuard
                        layout={
                            <TenantGurd>
                                <BoardLayout />
                            </TenantGurd>
                        }
                    />
                }
            >
                {protectedRoutes.map(route => (
                    <Route
                        key={route.key}
                        path={route.path}
                        element={
                            <AuthorityGuard key={route.key}>
                                <AppRoute routeKey={route.key} component={route.component} />
                            </AuthorityGuard>
                        }
                    >
                        {route.subRoute &&
                            route.subRoute.map(subRoute => (
                                <Route
                                    key={subRoute.key}
                                    path={subRoute.path}
                                    element={
                                        <AuthorityGuard>
                                            <AppRoute routeKey={subRoute.key} component={subRoute.component} />
                                        </AuthorityGuard>
                                    }
                                />
                            ))}
                    </Route>
                ))}
            </Route>
            <Route key={'AuthRoutes'} path="/auth/" element={<AuthRouteRenderer />}>
                {authRoutes.map(route => (
                    <Route
                        key={route.key}
                        path={route.path}
                        element={<AppRoute routeKey={route.key} component={route.component} />}
                    />
                ))}
            </Route>
            <Route key={'PublicRoutes'} path="/public/" element={<PublicRouteRenderer />}>
                {publicRoutes.map(route => (
                    <Route
                        key={route.key}
                        path={route.path}
                        element={<AppRoute routeKey={route.key} component={route.component} />}
                    />
                ))}
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
const Views = () => {
    return (
        <Suspense fallback={<Loader />}>
            <AllRoutes />
        </Suspense>
    );
};

export default Views;
